import {  Tabs } from "antd";
import SavedJobs from "./SavedJobs";
import AppliedJobs from "./AppliedJobs";

const MyJobs = () => {
  return (
    <div className="max-w-6xl mx-auto my-12 __job__list_container px-5 md:px-0">
      <h1
        className="text-4xl md:text-4xl font-extrabold leading-tighter  tracking-tighter mb-4"
        data-aos="zoom-y-out"
      >
        My Jobs
      </h1>
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: "Applied",
            key: "1",
            children: <AppliedJobs />,
          },
          {
            label: "Saved",
            key: "2",
            children: <SavedJobs />,
          },
        ]}
      />
    </div>
  );
};

export default MyJobs;
